import {
  Plane,
  BookCheck,
  Building2,
  Car,
  ShieldCheck,
  Briefcase,
  Ship,
  Palmtree,
  Headphones,
  BadgeCheck,
  Zap,
  Globe2,
  Sparkles,
  FileText,
  TrendingDown,
  UserCheck,
  BarChart3,
  Users,
} from "lucide-react";

const MAP = {
  Plane,
  BookCheck,
  Building2,
  Car,
  ShieldCheck,
  Briefcase,
  Ship,
  Palmtree,
  Headphones,
  BadgeCheck,
  Zap,
  Globe2,
  Sparkles,
  FileText,
  TrendingDown,
  UserCheck,
  BarChart3,
  Users,
};

export const ServiceIcon = ({ name, className = "h-6 w-6", strokeWidth = 1.5 }) => {
  const Icon = MAP[name] || Sparkles;
  return <Icon className={className} strokeWidth={strokeWidth} />;
};

export default ServiceIcon;
